import api from '@/lib/axios';

// School-tier admin dashboard for PGC (Parent Guidance Council). Web admin
// only — no parent mobile-submission flow here. Status is strictly
// 'pending' | 'completed' (confirmed against real legacy data — no
// in_progress state exists in the real implementation).

export type PgcStatus = 'pending' | 'completed';

export interface PgcStatusHistoryEntry {
  time: string;
  status: PgcStatus;
  updated_by: string;
  updated_by_name: string;
}

export interface PgcRegistrationRow {
  id: string;
  studentId: string;
  studentName: string | null;
  parentId: string;
  parentName: string | null;
  parentMobile: string | null;
  reason: string | null;
  status: PgcStatus;
  statusHistory: PgcStatusHistoryEntry[];
  counsellorNotes: string | null;
  counsellorReportUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePgcStatusData {
  status: PgcStatus;
  counsellorNotes?: string;
}

function unwrap<T>(r: { data: { data?: T } | T }): T {
  return ((r.data as { data?: T }).data ?? r.data) as T;
}

export const PgcRegistrationsApi = {
  list: async (status?: PgcStatus): Promise<PgcRegistrationRow[]> =>
    unwrap(await api.get('/school/pgc-registrations', { params: status ? { status } : undefined })),

  get: async (id: string): Promise<PgcRegistrationRow> => unwrap(await api.get(`/school/pgc-registrations/${id}`)),

  updateStatus: async (id: string, data: UpdatePgcStatusData): Promise<PgcRegistrationRow> =>
    unwrap(await api.patch(`/school/pgc-registrations/${id}/status`, data)),

  attachReport: async (id: string, reportUrl: string): Promise<PgcRegistrationRow> =>
    unwrap(await api.post(`/school/pgc-registrations/${id}/report`, { reportUrl })),

  remove: async (id: string): Promise<void> => unwrap(await api.delete(`/school/pgc-registrations/${id}`)),
};
